import React, { Component } from "react";
import ActionBookingPopup from "./ActionBookingPopup";
import { connect } from "react-redux";
import { getStatus, getType, getPaymentMethod } from "../../../config";

class BookingPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupVisible: false,
      popupActive: null
    };
  }
  componentWillMount() {
    document.addEventListener("keydown", this.handleEnterDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleEnterDown);
  }

  handleEnterDown = e => {
    if (e.keyCode === 27) {
      this.props.toggleFn(e);
    }
  }

  togglePopupClasses = (event, id) => {
    event.preventDefault();
    this.setState({ popupActive: this.state.popupActive !== id ? id : null });
  };

  render() {
    const bookingData =
      this.props.tickets.find(b => b.CardID === this.props.currentBooking);
    
    if(!bookingData) return null;

    const tripType = getType(bookingData.myTrips.length);
    const cardStatus = getStatus(bookingData.CardStatusID);
    const paymentMethod = getPaymentMethod(bookingData.CardTypeID);

    const goingTrip = bookingData.myTrips[0];
    const returningTrip = bookingData.myTrips[1];

    let coupon = null;
    let discountValue = 0;

    // console.log("Promo", bookingData.PromoCode);

    if(typeof bookingData.PromoCode === "string") {
      coupon = bookingData.PromoCode;
    } else if (typeof bookingData.PromoCode === "object" && bookingData.PromoCode !== null) {
      coupon = bookingData.PromoCode.code;
      discountValue = bookingData.PromoCode.val;
    }

    const totalValue = Number(bookingData.CardTotalPrice.replace(",", '')) + discountValue;

    return (
      <React.Fragment>
        <div
          data-status={cardStatus}
          className={`popup view-booking-popup ${
            this.props.currentBooking ? "popup_visible" : ""
          }`}
        >
          <div className="tbl">
            <div className="tcl">
              <div className="popup__window">
                <button
                  type="button"
                  className="popup__close material-icons js-popup-closer"
                  onClick={event =>
                    this.props.toggleFn(event, this.props.currentBooking)
                  }
                >
                  close
                </button>
                <div className={`view-booking-container ${cardStatus}`}>
                  <div className="card booking-info">
                    <h5 className="label">Booking No.</h5>
                    <p className="book-no">
                      {bookingData.CardID}
                      <span className={`booking-status ${cardStatus}`}>
                        {cardStatus}
                      </span>
                    </p>
                    <div className="booking-info-data">
                      <h4>Booking Date.</h4>
                      <p>{bookingData.ActionDate}</p>
                    </div>
                    <div className="booking-info-data">
                      <h4>Booking Type.</h4>
                      <p>{tripType}</p>
                    </div>
                    <div className="booking-info-data">
                      <h4>Payment Method</h4>
                      <p>{paymentMethod}</p>
                    </div>
                  </div>

                  <div className="card booking-trips">
                    <div className="booking-trip">
                      <h5 className="booking-trip-type">
                        <i className="material-icons">check</i>Going Trip
                      </h5>
                      <p className="booking-trip-data">
                        NS001-110619
                        <br />
                        {goingTrip.TripOfficeFrom}
                        <br />
                        {goingTrip.TripOfficeTo}
                        <br />
                        {/* 09 Mar 2019 03:00 PM */}
                        {goingTrip.TripDateTime}
                      </p>
                      <ul className="seats">
                        {goingTrip.Seats.map(s => (
                          <li key={s}>{s}</li>
                        ))}
                      </ul>
                      <div className="price-details">
                        <h4>{goingTrip.TripTotalPrice}.00 EGP</h4>
                        <p>{goingTrip.TripServKind}</p>
                      </div>
                    </div>
                    {returningTrip && (
                      <div className="booking-trip">
                        <h5 className="booking-trip-type">
                          <i className="material-icons">check</i>Return Trip
                        </h5>
                        <p className="booking-trip-data">
                          NS001-110619 <br />
                          {returningTrip.TripOfficeFrom}
                          <br />
                          {returningTrip.TripOfficeTo}
                          <br />
                          {returningTrip.TripDateTime}
                        </p>
                        <ul className="seats">
                          {returningTrip.Seats.map(s => (
                            <li key={s}>{s}</li>
                          ))}
                        </ul>
                        <div className="price-details">
                          <h4>{returningTrip.TripTotalPrice}.00 EGP</h4>
                          <p>{returningTrip.TripServKind}</p>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="card booking-prices">
                    <div className="price-details">
                      <h5 className="label">Total</h5>
                      <h4>{totalValue}.00 EGP</h4>
                      {/* <p>Regular</p> */}
                    </div>
                    <div className="price-details">
                      <h5 className="label">discount</h5>
                      <h4>{coupon && discountValue?  discountValue + ".00": "0.00"} EGP</h4>
                      <p>Promo: {coupon? coupon : ""}</p>
                    </div>
                    <div className="price-details">
                      <h5 className="label">Grand Total</h5>
                      <h4>{(totalValue - discountValue) + ".00"} EGP</h4>
                      {/* <p>Regular</p> */}
                    </div>
                  </div>

                  <div className="card booking-user-data">
                    <div className="data">
                      <div className="price-details">
                        <h5 className="label">Customer Details</h5>
                        <h4>{decodeURI(bookingData.UserName)}</h4>
                        <p>
                          {bookingData.UserEmail}
                          <br />
                          {bookingData.UserTelNo}
                          <br />
                          Passengers: {goingTrip.TripSeatsCount}
                        </p>
                      </div>
                      {
                        bookingData.BeneficiaryName &&
                        bookingData.BeneficiaryPhone && (
                          <div className="price-details">
                            <h5 className="label">Beneficiary</h5>
                            <h4>{decodeURI(bookingData.BeneficiaryName)}</h4>
                            <p>
                              --
                              <br />
                              {bookingData.BeneficiaryPhone}
                            </p>
                          </div>
                        )
                      }
                    </div>
                    {/* <div className="actions">
                      {bookingData.CardTypeID === cardTypes.cash && cardStatus !== "confirmed" && (
                        <Btn
                          className="btn confirm"
                          onClick={event => {
                            this.togglePopupClasses(event, bookingData.CardID);
                          }}
                        >
                          Confirm Booking
                        </Btn>
                      )}
                      {bookingData.CardTypeID === cardTypes.cc && (
                        <Btn
                          className="btn cancel"
                          onClick={event =>
                            this.togglePopupClasses(event, bookingData.CardID)
                          }
                        >
                          Cancel Booking
                        </Btn>
                      )}
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ActionBookingPopup
          currentBooking={this.state.popupActive}
          bookingData={bookingData}
          toggleFn={this.togglePopupClasses}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  tickets: state.tickets.tickets
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingPopup);
